import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import Sticker from './Sticker';
import {useSelector} from 'react-redux'
import { getPageLayer } from '../utils/toolbox';

function isSignableAndSingleUse(evalSticker, signableStickers) {
    if(evalSticker?.authority.singleUse) {
        const signableSingleUse = signableStickers.find(ss => evalSticker._id === ss.id);
        if(signableSingleUse) {
            return true;
        }
    }
    return false;
}

function isPartOfBoxGroupButNotSignable(evalSticker, signableStickers) {
    const otherStickers = signableStickers.filter(ss => evalSticker._id !== ss.id);
    for(let sb of otherStickers) {
        if(sb.sticker.boxGroup && sb.sticker.boxGroup === evalSticker.boxGroup) {
            return true;
        }
    }
    return false;
}

export default function StickerLayer({page, stickers, pageRendered, onClickOwner, editable, activeSigner, activeSignerFound}) {

    const [container] = useState(document.createElement('div'))
    const [pageHeight, setPageHeight] = useState(0)
    const activeSticker = useSelector(state => state.signableStickers.active)
    const signableStickers = useSelector(state => state.signableStickers.signableStickers);

    useEffect(() => {
        if(pageRendered) {
            // renderizamos la capa de stickers sobre cada pagina renderizada
            const pageLayer = getPageLayer(page)
            if(!pageLayer) {
                return;
            }
            setPageHeight(pageLayer.offsetHeight)
            container.id = `sticker-layer-${page}`;
            container.className = 'stickerLayer'
            pageLayer.appendChild(container);
            return () => {
                pageLayer.removeChild(container);
            }
        }
    }, [pageRendered, container, page])

    function shouldRenderSticker(s) {

        if(signableStickers && signableStickers.length > 0) {
            if(isSignableAndSingleUse(s, signableStickers)) {
                return true;
            }

            if(isPartOfBoxGroupButNotSignable(s, signableStickers)) {
                return false;
            }

        }
        if(!activeSticker || activeSticker.status === 'click') {
            return true;
        }
        if(!s.boxGroup) {
            return true;
        }
        if(s.boxGroup !== activeSticker.boxGroup) {
            return true;
        }
        return s._id === activeSticker.id;

    }

    return ReactDOM.createPortal((
        <div className="stickers">
            {
                stickers
                    .filter(s => shouldRenderSticker(s))
                    .map((s, i) => (
                    <Sticker key={i} {...s} pageHeight={pageHeight}
                        onClickOwner={() => onClickOwner(s)}
                        editable={editable}
                        signing={activeSticker != null && s._id === activeSticker.id && activeSticker.status !== 'click'}
                        activeSigner={activeSigner}
                        activeSignerFound={activeSignerFound}/>
                ))
            }
        </div>), container)
}
